"use client";

import React from "react";
import { CheckCircle2 } from "lucide-react";

interface MatchFactorBadgeProps {
  label: string;
  matched: boolean;
}

export const MatchFactorBadge = React.memo(function MatchFactorBadge({
  label,
  matched,
}: MatchFactorBadgeProps) {
  if (!matched) return null;

  return (
    <div className="flex items-center gap-1 px-2 py-1 bg-green-50 dark:bg-green-950/40 border border-green-200 dark:border-green-800 rounded text-xs text-green-700 dark:text-green-300">
      <CheckCircle2 className="w-3 h-3" />
      {label}
    </div>
  );
});
